import { colors } from '../themes/theme';
import type { Market, Outcome } from '../schemas/market.schema';

/**
 * Colour for one outcome.
 *
 * A two-way market reads as win/lose, which is the whole point of reserving
 * green and red for exactly that. Anything wider is a field, where those two
 * would imply a right answer, so it cycles a neutral set instead.
 */
const FIELD_PALETTE = [
    colors.safety,
    '#4C9BE8',
    '#B77BE0',
    '#E8B54C',
    '#4CC7B0',
    '#E87FA8',
] as const;

export const outcomeColor = (index: number, total: number): string => {
    if (total === 2) return index === 0 ? colors.win : colors.loss;
    return FIELD_PALETTE[index % FIELD_PALETTE.length] as string;
};

/** What a winning token returns, or null before anyone has backed it. */
export const payoutHint = (outcome: Outcome, market: Market, extraStake = 0): number | null => {
    const winningPool = outcome.staked + extraStake;
    if (winningPool <= 0) return null;
    return (market.pot + extraStake) / winningPool;
};
